<script setup>
const siteConfig = useSiteConfig();

</script>

<template>
<div class="grid grid-cols-1 md:flex md:justify-between gap-6 md:gap-4 text-sm">
  <div class="flex flex-col gap-6 md:gap-4 font-light">
    <div class="uppercase">Oferta</div>
    <div class="flex flex-col gap-2">
      <NuxtLink :to="{name:'static-offer-entrepreneur'}">Leasing dla firm</NuxtLink>
      <NuxtLink :to="{name:'static-offer-consumer'}">Leasing konsumencki</NuxtLink>
      <NuxtLink :to="{name:'static-insurances'}">Ubezpieczenia VEHIS</NuxtLink>
    </div>
  </div>

  <div class="flex flex-col gap-6 md:gap-4 font-light">
    <div class="uppercase">O nas</div>
    <div class="flex flex-col gap-2">
      <NuxtLink :to="useBackend().getDownloadLinkForFile('services')" external>Partnerzy serwisowi</NuxtLink>
      <NuxtLink :to="{name:'static-regulations'}" rel="noindex">Regulaminy i dokumenty</NuxtLink>
      <NuxtLink to="/komunikaty" rel="noindex">Relacje inwestorskie</NuxtLink>
    </div>
  </div>

  <div class="flex flex-col gap-6 md:gap-4 font-light">
    <div class="uppercase">Kontakt</div>
    <div class="flex flex-col gap-2">
      <div>Biuro Obsługi Klienta</div>
      <div class="flex gap-2 items-center"><IconPhone stroke="#000000" /> {{ siteConfig.bokPhone }}</div>
    </div>

    <ButtonRounded 
      class="bg-sad-pink border-sad-pink max-w-36 lg:max-w-48 lg:min-w-48"
      href="https://klient.vehis.pl"
      target="_blank"
      with-icon
      no-inner-padding
    >
      <IconUser class="mr-2"/>
      Portal Klienta
    </ButtonRounded>
  </div>

  <div class="flex flex-col gap-6 md:gap-4 font-light">
    <div>Jesteśmy członkiem</div>
    <div class="-mt-2">
      <VectorZplLogoColor class="md:w-[140px]"/>
    </div>
  </div>
</div>
</template>
